import gql from 'graphql-tag';

export const MILESTONES = gql`
  query milestones(
    $where: MilestoneWhereInput
    $orderBy: MilestoneOrderByInput
    $first: Int
    $skip: Int
    $after: String
  ) {
    milestonesConnection(
      where: $where
      orderBy: $orderBy
      first: $first
      skip: $skip
      after: $after
    ) {
      edges {
        node {
          id
          name
          description
          startDate
          dueDate
          status
          createdAt
          updatedAt
          project {
            id
            name
          }
          tasks {
            id
            name
            status
            startDate
            createdAt
            dueDate
            requestType
            assigneeUsers {
              id
              username
              name
              avatar {
                key
                url
              }
            }
            channelPartner {
              id
              name
            }
            advertiser {
              id
              name
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      aggregate {
        count
      }
    }
  }
`;

export default MILESTONES;
